import React from 'react';

const urlRegex = /(https?:\/\/[^\s]+|www\.[^\s]+)/gi;

function ensureProtocol(url) {
  if (/^https?:\/\//i.test(url)) {
    return url;
  }
  return `https://${url}`;
}

export default function LinkifiedText({ text, className, style }) {
  if (!text) {
    return null;
  }

  const segments = [];
  let lastIndex = 0;

  text.replace(urlRegex, (match, _capture, offset) => {
    if (offset > lastIndex) {
      segments.push({ type: 'text', value: text.slice(lastIndex, offset) });
    }
    segments.push({ type: 'link', value: match });
    lastIndex = offset + match.length;
    return match;
  });

  if (lastIndex < text.length) {
    segments.push({ type: 'text', value: text.slice(lastIndex) });
  }

  return (
    <span className={className} style={{ whiteSpace: 'pre-wrap', ...style }}>
      {segments.map((segment, index) => {
        if (segment.type === 'link') {
          return (
            <a
              key={`link-${index}`}
              href={ensureProtocol(segment.value)}
              target="_blank"
              rel="noopener noreferrer"
            >
              {segment.value}
            </a>
          );
        }
        return <React.Fragment key={`text-${index}`}>{segment.value}</React.Fragment>;
      })}
    </span>
  );
}
